import Config from "../models/config";
import { IOffDaysWfhDays, OffDaysWfhDays } from "../models/offDaysWfhDays";
import { ISprint, Sprint } from "../models/sprint";
import { IWfhDayOffDay, WfhDayOffDay } from "../models/wfhDayoffDayRegister";
import { IWorkingTime } from "../models/workingTime";
import { formatDate } from "./date";
import { removeNumberSignOfReason } from "./string";

//x: IWorkingtime
export const getReason = (x: IWorkingTime) => {
    let slot = x.slot;
    let [hi, mi] = x.checkin.split(":");
    let [ho, mo] = x.checkout.split(":");
    let reason = "";
    let subPoint = 0;
    if (!hi || !ho) {
        reason += (!hi ? "không checkin, " : "") + (!ho ? "không checkout, " : "");
        subPoint = subPoint + (!hi ? Config.LATE.notcheck : 0) + (!ho ? Config.LATE.notcheck : 0);
    }
    let timeIn = parseInt(hi) * 60 + parseInt(mi);
    let lateIn = 0;
    let isEarlyOut = false;
    if (slot === Config.ALL_DAY_VNESE) {
        lateIn = timeIn - Config.LATE.timeInMorning;
        isEarlyOut = x.checkout < Config.CHECKOUT_AFTERNOON && !!x.checkout;
    } else if (slot === Config.MORNING_VNESE) {
        lateIn = timeIn - Config.LATE.timeInMorning;
        isEarlyOut = x.checkout < Config.CHECKOUT_MORNING && !!x.checkout;
    } else if (slot === Config.AFTERNOON_VNESE) {
        lateIn = timeIn - Config.LATE.timeInAfternoon;
        isEarlyOut = x.checkout < Config.CHECKOUT_AFTERNOON && !!x.checkout;
    }
    if (lateIn >= 0) {
        reason += "muộn " + lateIn + " phút, ";
        if (lateIn >= Config.LATE.lte10.gt && lateIn < Config.LATE.lte10.lte) {
            subPoint += Config.LATE.lte10.des;
        }
        if (lateIn >= Config.LATE.gt10lte20.gt && lateIn < Config.LATE.gt10lte20.lte) {
            subPoint += Config.LATE.gt10lte20.des;
        }
        if (lateIn >= Config.LATE.gt20.gt) {
            subPoint += Config.LATE.gt20.des;
        }
    }
    if (isEarlyOut) {
        reason += "checkout sớm, ";
        subPoint += Config.LATE.notcheck;
    }
    return {
        reason: slot + " (" + x.checkin + " - " + x.checkout + ") " + reason + "trừ " + subPoint + " điểm",
        point: subPoint,
    };
};

/** update ngày 27/4/2023 (sprint 88):
 ** nghỉ bao nhiêu phút trừ bấy nhiêu điểm, tối đa 60 điểm (2h => sau 10h30 sáng hoặc sau 15h30 chiều) (tương đương trường hợp không checkin)
 ** không checkout (~ checkout sớm (trước 10h00 sáng hoặc trước 16h00 chiều)) trừ 15 điểm
 @returns lý do và số điểm bị trừ*/
export const getReason2 = (x: IWorkingTime) => {
    let slot = x.slot;
    let [hi, mi] = x.checkin.split(":");
    let [ho, mo] = x.checkout.split(":");
    let reason = "";
    let subPoint = 0;
    if (!hi || !ho) {
        reason += (!hi ? "không checkin, " : "") + (!ho ? "không checkout, " : "");
        subPoint = subPoint + (!hi ? Config.LATE88.notCheckin : 0) + (!ho ? Config.LATE88.notCheckout : 0);
    }
    let timeIn = parseInt(hi) * 60 + parseInt(mi);
    let lateIn = 0;
    let isEarlyOut = false;
    if (slot === Config.ALL_DAY_VNESE) {
        // trường hợp làm cả ngày
        lateIn = timeIn - Config.LATE88.timeInMorning; // thời gian checkin trễ buổi sáng
        isEarlyOut = x.checkout < Config.CHECKOUT_AFTERNOON && !!x.checkout; // checkout sớm
    } else if (slot === Config.MORNING_VNESE) {
        // trường hợp chỉ làm sáng
        lateIn = timeIn - Config.LATE88.timeInMorning; // thời gian đi trễ buổi chiều
        isEarlyOut = x.checkout < Config.CHECKOUT_MORNING && !!x.checkout; // checkout sơm
    } else if (slot === Config.AFTERNOON_VNESE) {
        // trường hợp chỉ làm chiều
        lateIn = timeIn - Config.LATE88.timeInAfternoon; // thời gian đi trễ buổi chiều
        isEarlyOut = x.checkout < Config.CHECKOUT_AFTERNOON && !!x.checkout; // checkout sớm
    }
    if (lateIn >= 0) {
        reason += "muộn " + lateIn + " phút, ";

        if (lateIn >= Config.LATE88.gt60.gt) {
            // muộn quá 60p thì chỉ trừ 60 điểm thôi
            subPoint += Config.LATE88.gt60.des;
        } else {
            subPoint += lateIn; // muộn bnh phút trừ bấy nhiêu điểm
        }
    }
    if (isEarlyOut) {
        reason += "checkout sớm, ";
        subPoint += Config.LATE88.notCheckout;
    }
    return {
        reason: slot + " (" + x.checkin + " - " + x.checkout + ") " + reason + "trừ " + subPoint + " điểm",
        point: subPoint,
    };
};
/**
 * Tien xu ly du lieu chấm công, matching với dữ liệu xin nghỉ/ nghỉ lễ, làm bù ,...
 * @param workingDayList array[], truong 'date' phai duoc convert theo timezone truoc khi truyen vao
 * @param offDaysWfhDays array[], truong 'date' phai duoc convert theo timezone truoc khi truyen vao
 * @returns
 */
const CHECKIN_TO_CHECKOUT_MORNING = "11:00";
const CHECKIN_TO_CHECKOUT_AFTERNOON = "17:00";
export const handleWorkingDay = (workingDayList: IWorkingTime[], offDaysWfhDays: IOffDaysWfhDays[]) => {
    return workingDayList
        .map((item: any) => {
            let userData = offDaysWfhDays.find((r: any) => r?.userId?.toString() === item?.userId?.toString());
            if (userData) {
                let res: any = {};
                for (let key in item) {
                    res[key] = item[key];
                }

                let offday = userData.offDays.filter(
                    (od: any) => new Date(od?.date).getTime() == new Date(item?.date).getTime()
                );
                // xin nghỉ được lưu riêng từng buổi (không lưu allday nữa nha)
                if (offday.length) {
                    // co nghi
                    if (offday.length == 2) return null; // nghi ca ngay thi khong check di muon
                    else if (offday.length == 1) {
                        if (offday[0].slot === Config.MORNING_VNESE) {
                            // nghi sang thi check di muon chieu
                            res["slot"] = Config.AFTERNOON_VNESE;
                            let check = checkLate(item.checkin, 1, item.checkout);
                            if (!check) return null;
                        } else if (offday[0].slot === Config.AFTERNOON_VNESE) {
                            //nghi chieu thi check di muon sang
                            res["slot"] = Config.MORNING_VNESE;
                            let check = checkLate(item.checkin, 0, item.checkout);
                            if (!check) return null;
                        } else if (offday[0].slot === Config.ALL_DAY_VNESE) return null; // nghi ca ngay thi khong check di muon // vẫn còn trường hợp nghỉ cả ngày là intern
                    }
                } else {
                    //*_bug_* khong nghi = mac dinh la di lam ca ngay !!! sai !!! vi co the cty di lam sang/ chieu
                    let session = 0;
                    if (item.slot === Config.AFTERNOON) session = 1;
                    let check = checkLate(item.checkin, session, item.checkout);
                    res["slot"] = Config.ALL_DAY_VNESE;
                    if (!check) return null;
                }
                //---------------------- không còn wfh nữa nên cũng không cần quan tâm đoạn dưới này
                let wfhday = userData?.wfhDays?.find(
                    (wfh: any) => new Date(wfh?.date).getTime() == new Date(item?.date).getTime()
                );
                if (wfhday) {
                    //co lam online
                    if (wfhday.slot === Config.ALL_DAY_VNESE) return null; // onl ca ngay thi khong check di muon
                    else if (wfhday.slot === Config.MORNING_VNESE) {
                        // onl sang thi check di muon chieu
                        if (res?.slot === Config.MORNING_VNESE) return null; //trung lich lam onl thi khong can xet di muon
                        res["slot"] = Config.AFTERNOON_VNESE;
                        let check = checkLate(item.checkin, 1, item.checkout);
                        if (!check) return null;
                    } else if (wfhday.slot === Config.AFTERNOON_VNESE) {
                        //onl chieu thi check di muon sang
                        if (res?.slot === Config.AFTERNOON_VNESE) return null; //trung lich lam onl thi khong can xet di muon
                        res["slot"] = Config.MORNING_VNESE;
                        let check = checkLate(item.checkin, 0, item.checkout);
                        if (!check) return null;
                    }
                } else {
                    // da check o phan offday
                }
                return res;
            }
            return null;
        })
        .filter((item: any) => !!item)
        .map((item) => {
            let slot = item.slot;
            // xử lý trường hợp quên checkin nma có checkout, thì máy ghi nhận là checkin (vào giờ checkout) mà không có checkout
            // chỉ xét chuyển đổi trong thời gian 1 tiếng cuối cùng của ca làm (vd trường hợp sáng ghi nhận checkin sau 11h mới được coi là checkout...)
            if (!!item.checkin || !item.checkout) {
                if (slot === Config.ALL_DAY_VNESE || slot === Config.AFTERNOON_VNESE) {
                    // trường hợp làm cả ngày hoặc chỉ làm chiều
                    if (item.checkin > CHECKIN_TO_CHECKOUT_AFTERNOON) {
                        item.checkout = item.checkin;
                        item.checkin = "";
                    }
                } else if (slot === Config.MORNING_VNESE) {
                    // trường hợp chỉ làm sáng
                    if (item.checkin > CHECKIN_TO_CHECKOUT_MORNING) {
                        item.checkout = item.checkin;
                        item.checkin = "";
                    }
                }
            }
            return item;
        });
};

const checkLate = (checkin: any, session = 0 | 1, checkout: any) => {
    //1: chieu
    //0: sang
    if (!checkin || !checkout) return true;
    let [h, m] = checkin.split(":");
    h = parseInt(h);
    m = parseInt(m);
    if (session == 0) {
        if (h * 60 + m > Config.LATE.timeInMorning) return true;
    } else if (session == 1) {
        if (h * 60 + m > Config.LATE.timeInAfternoon) return true;
    }
    return false;
};
/** điểm bị trừ theo loại lỗi
 * nếu có dấu - trong offType thì mặc định trừ thêm 30 điểm nữa
 */
export const calculateDisciplinePoints = (sprint: ISprint, offDaysWfhDay?: IOffDaysWfhDays, workingTime?: IWorkingTime[]) => {
    let score = 0;
    // let onlDay = 0;
    sprint = new Sprint(sprint);

    let numOfOffDay = 0;
    if (workingTime?.length) {
        workingTime = workingTime.map((x) => {
            let milestone = new Date("05/01/2024").getTime();
            let { reason, point } = x.date.getTime() < milestone ? getReason(x) : getReason2(x);
            score += point;
            return {
                ...x,
                reason: reason,
            };
        });
    }

    let offday: IWfhDayOffDay[] = [];
    if (offDaysWfhDay?.offDays?.length) {
        //nghi khong phep
        offday = offDaysWfhDay.offDays;
        let firstUrgent = true;
        let countSlot = 0;
        let offsetScore = 0;
        offday = offday
            .map((d) => {
                let _score = 0;
                let _offsetScore = 0;
                if (!d?.offType) return new WfhDayOffDay();
                if (
                    new Date(d.date).getTime() >= new Date(sprint?.startDate).getTime() &&
                    new Date(d.date).getTime() <= new Date(sprint?.endDate).getTime()
                ) {
                    let _offType = d?.offType?.replace("-", "");
                    let num = offday.filter(
                        (_d) => new Date(d.date).getTime() == new Date(_d.date).getTime() && d.offType === _d.offType
                    ).length;
                    if (Config.OFF_TYPE[_offType]) {
                        // xử lý trường hợp chung (trừ điểm theo lỗi của lần nghỉ đầu tiên)
                        _score = Config.OFF_TYPE[_offType];
                        if (parseInt(sprint.shortId) > 81) {
                            _score = _score / num;
                        } else {
                            _offsetScore = _score / 2; // vì duyệt theo từng buổi nên chỗ này bị /2
                            if (d.offType == Config.OFF_TYPE_UNAUTHORIZED) {
                                // bổ sung theo logic mới ngày 12/12/2023: không lưu allday được nữa mà luật nghỉ không phép là trừ 30 điểm 1 LẦN nên trường hợp nghỉ cả ngày sẽ lưu thành 2 lần
                                // nên check lại chỗ này để chia đều số điểm bị trừ cho số slot trong 1 ngày đó
                                let _num = offday.filter(
                                    (_d) =>
                                        new Date(d.date).getTime() == new Date(_d.date).getTime() &&
                                        d.offType === Config.OFF_TYPE_UNAUTHORIZED
                                ).length;
                                _score = _score / _num;
                            }
                        }
                    }
                    if (d.slot !== Config.ALL_DAY_VNESE) numOfOffDay += 0.5;
                    else {
                        numOfOffDay += 1;
                        if (d.offType !== Config.OFF_TYPE_UNAUTHORIZED) _score *= 2;
                    }
                    if (parseInt(sprint.shortId) > 81) {
                        // xử lý trường hợp nghỉ từ lần thứ 2 trở đi (có dấu - trong offType)
                        // xét riêng cho update ngày 1/2/2023 (ứng vs sprint 82)
                        // offType sẽ có thêm dấu - để nhận biết ngày nghỉ này có bị trừ điểm hay không (ở tragn đăng ký đã check r, có dấu - thì trừ thêm 30 điểm)
                        // trừ theo LẦN nhé, và duyệt trong 1 tháng nên cần xử lý lại chỗ này
                        if (d?.offType.includes("-")) {
                            _score += Config.OFF_TYPE[Config.OFF_TYPE_DEFAULT] / num;
                        } else {
                            // trường hợp intern không đăng ký hoặc trường hợp xin nghỉ lần đầu tiên và trước 17h thì không ghi lỗi (vì offType == '')
                            if (!d.offType || d.offType === Config.OFF_TYPE_AUTHORIZED) return new WfhDayOffDay();
                        }
                    } else {
                        if (
                            (d?.offType?.includes(Config.OFF_TYPE_URGENT_1) ||
                                d?.offType?.includes(Config.OFF_TYPE_URGENT_2)) &&
                            firstUrgent
                        ) {
                            //bo qua lan vi pham dau tien
                            let isOk = true;
                            let slotsOfDay = offday.filter((_d) => new Date(d.date).getTime() == new Date(_d.date).getTime());
                            if (slotsOfDay.length == 1)
                                // nếu chỉ nghỉ 1 buổi trong ngày hôm đó thì nó cũng là lần đầu tiên cho phép luôn
                                firstUrgent = false;
                            else if (slotsOfDay.length == 2) {
                                // nếu nghỉ 2 buổi thì cần phải xem 2 buổi này có xin cùng nhau không hay buổi nào xin sau sẽ bị tính, căn cứ vào timeStamp trong reason
                                let timeStamp1 = slotsOfDay[0].reason.split("#").pop();
                                let timeStamp2 = slotsOfDay[1].reason.split("#").pop();
                                let isNotOkTimeStamp;

                                if (timeStamp1 && timeStamp2) {
                                    // nếu cả 2 có timeStamp
                                    if (timeStamp1 !== timeStamp2) {
                                        // 2 timeStamp khác nhau thì 1 trong 2 slot sẽ là trừ điểm (cái lớn hơn)
                                        isNotOkTimeStamp = timeStamp1?.localeCompare(timeStamp2) > 0 ? timeStamp1 : timeStamp2;

                                        if (d.reason.includes(isNotOkTimeStamp)) {
                                            isOk = false;
                                        }
                                    }
                                } else if (timeStamp1 || timeStamp2) {
                                    // trường hợp 1 trong 2 slot có timeStamp (logic mới thì mới có) thì coi như nó là lần đăng ký quá lượt rồi
                                    isNotOkTimeStamp = timeStamp1 ?? timeStamp2 ?? "#";
                                    if (d.reason.includes(isNotOkTimeStamp)) {
                                        isOk = false;
                                    }
                                }
                                // trong ngày hôm đó dù thế nào thì cũng phỉa xét xong cả ngày mới cần gán firstUrgent nên viết ra ngoài cùng như này
                                countSlot++;
                                if (countSlot == 2) firstUrgent = false;
                            }
                            if (isOk) {
                                _score = 0;
                                return new WfhDayOffDay();
                            }
                        }
                    }
                    score += _score;
                }
                let offType = "";
                if (d?.offType && Config.OFF_TYPE[d?.offType.replace("-", "")] && d?.offType !== Config.OFF_TYPE_UNAUTHORIZED) {
                    if (d?.offType?.includes(Config.OFF_TYPE_URGENT_1)) offType = "Nghỉ khẩn cấp mức 1";
                    if (d?.offType?.includes(Config.OFF_TYPE_URGENT_2)) offType = "Nghỉ khẩn cấp mức 2";
                    if (d?.offType?.includes("-")) offType += "-";
                    offType += ", ";
                }
                return {
                    ...d,
                    reason: d.slot + ", " + offType + removeNumberSignOfReason(d.reason) + ", trừ " + _score + " điểm",
                };
            })
            .filter(
                (d) =>
                    !!d._id &&
                    d.offType &&
                    d.offType !== Config.OFF_TYPE_AUTHORIZED &&
                    new Date(d.date).getTime() >= new Date(sprint?.startDate).getTime() &&
                    new Date(d.date).getTime() <= new Date(sprint?.endDate).getTime()
            );
        score -= offsetScore;
    }
    return {
        minusScore: score,
        offDaysUnauthorized: offday,
        workingTime: workingTime ?? [],
        offDay: numOfOffDay,
    };
};

export const converDisciplineDataToReport = (sprint: ISprint, offDaysWfhDay: OffDaysWfhDays, workingTime: IWorkingTime[]) => {
    let discipline = calculateDisciplinePoints(sprint, offDaysWfhDay, workingTime);
    let result = {
        minusScore: discipline.minusScore,
        offDaysUnauthorized: discipline.offDaysUnauthorized.map(
            (day: any) => formatDate(new Date(day.date), "yyyy/mm/dd") + ": " + day.reason
        ),
        workingTime: discipline.workingTime.map((day: any) => formatDate(new Date(day.date), "yyyy/mm/dd") + ": " + day.reason),
    };
    return result;
};
